/* eslint-disable import/prefer-default-export */
export const SOCKET_CONNECTION_UPDATED = 'SOCKET_connectionUpdated';
